// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3kj5l","label":"Labeled_label__3ru0I","divider":"Labeled_divider__300op"};